import { camelCase } from 'lodash-es';
import * as React from 'react';
import { InjectedIntl } from 'react-intl';

import BooksTypeRadio from '../../../../components/books/common/buttons/BooksTypeRadio';

import * as IBooks from '../../../../interfaces/merchants/resources/books';

import css from './InputBookingTargetSwitch.module.scss';

interface Props {
  className?: string;
  intl: InjectedIntl;
  selected: IBooks.Switch;
  onClick: (select: IBooks.Switch) => void;
}

class InputBookingTargetSwitch extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  public handleClick(e: React.ChangeEvent<HTMLInputElement>) {
    const { onClick } = this.props;
    const selections = Object.values(IBooks.Switch);
    const selection = selections.find(s => s === e.currentTarget.value)!;
    onClick(selection);
  }

  public render() {
    const { selected, intl } = this.props;
    const selections = Object.values(IBooks.Switch);
    return (
      <div className={css.InputBookingTargetSwitch}>
        {selections.map(selection => (
          <BooksTypeRadio
            key={selection}
            name="switch"
            id={selection}
            value={selection}
            label={intl.formatMessage({
              id: `books.button.${camelCase(selection)}`,
            })}
            onChange={this.handleClick}
            checked={selection === selected}
          />
        ))}
      </div>
    );
  }
}

export default InputBookingTargetSwitch;
